import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {LayerModel} from '../../../../models/LayerModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-sl2-filter',
  templateUrl: './sl2-filter.component.html',
  styleUrls: ['./sl2-filter.component.scss']
})
export class Sl2FilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterLayer: any[];

  @Input() layerData: any;
  @Input() layerSelected: LayerModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('layerData' in changes) {
      this.listFilterLayer = this.layerData ? this.layerData : [];
      this.optionSelected = null;
    }
    if (this.layerSelected) {
      this.optionSelected = this.layerSelected;
    }
  }

  ngOnDestroy(): void {
  }
}
